// extracted by mini-css-extract-plugin
export default {"wrapper":"Close_wrapper__+0vlm","cross":"Close_cross__KeNEw"};